<!-- Nothing rendered when the note has no files: no empty container, no stray
     spacing. Hosts that used to wrap this in their own `@if` can drop it. -->
@if (attachments.length) {
  <div class="na-wrap" role="group" [attr.aria-label]="ariaLabel">

    <!-- One wrapping row of chips. `flex-wrap` is the entire layout change that
         multi-attachment needs — N chips flow onto as many lines as they need and
         each keeps the reference design's exact proportions. -->
    <div class="na-pills">
      @for (row of attachments; track trackRow($index, row)) {

        <!-- The reference chip, unchanged: paperclip, name, preview, remove.
             `title` sits on the NAME, never on the chip — a `title` on the chip is
             inherited for hover purposes, so pointing at the ✕ raises a native
             tooltip carrying the filename ON TOP OF the intended one. -->
        <span class="na-pill">
          <!-- Direct child of the chip, as `.nf-file` has it: the chip's own 6px
               gap spaces clip -> name -> control -> control uniformly, so there is
               no second gap to declare and nothing that can land between the two
               filename runs. -->
          <svg class="na-clip" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
          </svg>

          <!-- Two runs, adjacent: the head takes the ellipsis and the tail keeps the
               extension. They sit directly in the name because the chip's gap is on
               the CHIP, not here — nothing can open a hole mid-filename.

               The name is also the download affordance where the host offers one;
               there is no separate download button in the reference design. -->
          @if (showDownload) {
            <button type="button" class="na-name na-name-link" [title]="row.name"
                    [attr.aria-label]="'Download attachment ' + row.name"
                    (click)="onDownload(row)"><span class="na-name-head">{{ nameHead(row) }}</span>@if (nameTail(row)) {<span class="na-name-tail">{{ nameTail(row) }}</span>}</button>
          } @else {
            <span class="na-name" [title]="row.name"><span class="na-name-head">{{ nameHead(row) }}</span>@if (nameTail(row)) {<span class="na-name-tail">{{ nameTail(row) }}</span>}</span>
          }

          @if (canPreview(row)) {
            <button type="button" class="na-act tip tip-down tip-end" data-tip="Preview file"
                    (click)="onPreview(row)"
                    [attr.aria-label]="'Preview attachment ' + row.name">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
              </svg>
            </button>
          }

          @if (canDelete) {
            <button type="button" class="na-act na-del tip tip-down tip-end" [attr.data-tip]="tipFor(row)"
                    (click)="onDelete(row)"
                    [attr.aria-label]="tipFor(row) + ' ' + row.name">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          }
        </span>
      }
    </div>
  </div>
}
